import { createStore, combineReducers } from 'redux'
import { configure } from '../api'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import {
  selectedCurrency,
  setCurrency,
  itineraryPopupData,
} from '../actions/main-actions'
import { currencyDirective } from '../directives'
import { getLanguage, checkIsEditOrder, getTranslations } from 'utils'
import 'babel-polyfill'
import 'whatwg-fetch'

import ErrorHandler from '../components/ErrorHandler'
import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import ItineraryPage from '../pages/ItineraryPage'
import { createUrl } from '../localized-urls'
import { createRoot } from 'react-dom/client'

if(process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    ignoreErrors: [
      'AbortError',
      'UnhandledRejection',
      'Unexpected token o in JSON at position 1',
      'Anonymous function(/gtm.js)',
      "undefined is not an object (evaluating 'd.appendChild')",
      'chrome-extension',
      'gtm',
      'Illegal invocation',
      "Can't find variable: setIOSParameters",
      '(app-modern)',
      'd is undefined',
    ],
  })
}

checkIsEditOrder()

let store = createStore(
  combineReducers({
    selectedCurrency,
    itineraryPopupData,
  }),
)

let language = getLanguage()
let messages = {}

window.operatorStore = store
window.store = store
configure(store)

if(language !== 'en') {
  getTranslations(language, renderApp)
} else {
  renderApp()
}

function renderApp(translatedStrings) {
  if(translatedStrings) {
    messages = translatedStrings
  }
  currencyDirective(function(currency) {
    store.dispatch(setCurrency(currency))
  })
  const checkoutUrl = document.querySelectorAll('.cabin-price')
  if(checkoutUrl.length) {
    checkoutUrl.forEach((btn) => {
      btn.setAttribute(
        'href',
        createUrl('checkout_la', {
          location: window.countrySlug,
          slug: window.shopSlug,
        }),
      )
    })
  }
  renderElement('itinerary-data', ItineraryPage, {
    countrySlug: window.countrySlug,
    shopSlug: window.shopSlug,
    itinerarySlug: window.itinerarySlug,
  })
}

function renderElement(elem, ComponentToRender, props) {
  let element
  if(typeof elem === 'string') {
    element = document.getElementById(elem)
  } else {
    element = elem
  }

  if(element) {
    const root = createRoot(element)
    root.render(
      <IntlProvider
        locale={language === 'ach' ? 'en' : language}
        messages={messages}
        textComponent='span'
      >
        <Provider store={store}>
          <ErrorHandler>
            <ComponentToRender {...props} />
          </ErrorHandler>
        </Provider>
      </IntlProvider>,
    )
  }
}
